import React from 'react';
import cn from 'classnames';
import styles from './TableHead.module.scss';

const TableHead = ({ className, ...props }) => {
  return <thead {...props} className={cn(styles.tableHead, className)} />;
};

export default TableHead;
